// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import "./assets/css/base.css"
import 'iview/dist/styles/iview.css';
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Base from './utils/Base.js';
import iView from 'iview';
import App from './App'
import api from './http/index'
import router from './router'
import '@/assets/icon/iconfont.css'
import saveAs from './utils/FileSaver.js'
import "./utils/filter.js"
window.saveAs= saveAs.saveAs

import { isAuth } from '@/utils/permissions.js'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video
Vue.config.productionTip = false
Vue.use(iView);
Vue.use(api);
Vue.use(Viewer)

Vue.prototype.isAuth = isAuth     // 权限方法


window.Base = Base;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js